$(function() {
	$('[vendor_id]').each(function(index) {
		var $wrapper = $(this), $vendor = new tVendor($wrapper);
	});
});

function tVendor($wrapper)
{
	var $this = this,
		vendor_id = $wrapper.attr('vendor_id'),
		$addButton = $('.myVendorsAdd', $wrapper),
		$delButton = $('.myVendorsDel', $wrapper);

	this.getWrapper = function () {
		return $wrapper;
	}

	this.getName = function () {
		return $wrapper.attr('vendor_title');
	}

	this.getId = function () {
		return $wrapper.attr('vendor_id');
	}

	this.myVendorsAdd = function () {
		$addButton.hide();
		$delButton.show();
		$.ajax({
			type: "POST",
			url: '/oms/vendors.php?ajax=myVendorsAdd',
			data: {'vendor_id':vendor_id},
			dataType: 'json',
			success: function (data) {
				showToast(
					'success',
					'My Vendors',
					'just now',
					'<b>' + $this.getName() + '</b> is added to My Vendors',
					5000
				);
			}
		});
	}

	this.myVendorsDel = function () {
		$addButton.show();
		$delButton.hide();
		$.ajax({
			type: "POST",
			url: '/oms/vendors.php?ajax=myVendorsDel',
			data: {'vendor_id':vendor_id},
			dataType: 'json',
			success: function (data) {
				showToast(
					'info',
					'My Vendors',
					'just now',
					'<b>'+$this.getName()+'</b> is deleted from My Vendors',
					5000
				);
			}
		});
	}


	$('.myVendorsAdd', $wrapper).on('click', function () {
		$this.myVendorsAdd(this);
		return false;
	});

	$('.myVendorsDel', $wrapper).on('click', function () {
		$this.myVendorsDel();
		return false;
	});

	var $rating = new tVendorRating($this);
}


function tVendorRating($vendor)
{
	var $this = this,
		$wrapper = $('.ratingStars', $vendor.getWrapper());

	this.rating = $wrapper.attr('value');

	this.getStar = function (starValue, enabled) {
		return $('[value='+starValue+'][enabled='+enabled+']', $wrapper);
	}

	this.enableStar = function (starValue) {
		$this.getStar(starValue, 'false').hide();
		$this.getStar(starValue, 'true').show();
	}

	this.disableStar = function (starValue) {
		$this.getStar(starValue, 'false').show();
		$this.getStar(starValue, 'true').hide();
	}

	this.disableStars = function () {
		for (var i=1; i<=5; i++) {
			$this.disableStar(i);
		}
	}

	this.setRating = function (rating) {
		rating = parseInt(rating);
		$this.rating = rating;
		switch (rating) {
			case 1: $this.enableStar(1); $this.disableStar(2); $this.disableStar(3); $this.disableStar(4); $this.disableStar(5); break;
			case 2: $this.enableStar(1); $this.enableStar(2); $this.disableStar(3); $this.disableStar(4); $this.disableStar(5); break;
			case 3: $this.enableStar(1); $this.enableStar(2); $this.enableStar(3); $this.disableStar(4); $this.disableStar(5); break;
			case 4: $this.enableStar(1); $this.enableStar(2); $this.enableStar(3); $this.enableStar(4); $this.disableStar(5); break;
			case 5: $this.enableStar(1); $this.enableStar(2); $this.enableStar(3); $this.enableStar(4); $this.enableStar(5); break;
			default: $this.disableStars(); break;
		}
	}

	this.hover = function () {
		var starValue = $(this).attr('value');
		$this.setRating(starValue);
	}

	this.mouseleave = function () {
		$this.setRating($wrapper.attr('value'));
	}

	this.click = function () {
		var starValue = $(this).attr('value');

		if ($wrapper.hasClass('rated') && $wrapper.attr('value')==starValue) {
			// second click on the same star undos the vote
			$.ajax({
				type: "POST",
				url: '/oms/vendors.php?ajax=undoVendorRating',
				data: {'vendor_id':$vendor.getId()},
				dataType: 'json',
				success: function (data) {
					if ($wrapper.attr('averageRating')!='0') {
						$wrapper.html(data.stars);
						$this.assignEvents();
					}
				}
			});
			$wrapper.attr('value', $wrapper.attr('averageRating'));
			$wrapper.removeClass('rated');
			var i = $('.bg-warning .mr-auto:contains('+$vendor.getName()+')');
			if (i.length==0) {
				showToast(
					'warning',
					$vendor.getName(),
					'just now',
					'You rating is undone.',
					3000
				);
			}
		} else {
			$.ajax({
				type: "POST",
				url: '/oms/vendors.php?ajax=vendorRating',
				data: {'vendor_id':$vendor.getId(), 'rating':starValue},
				dataType: 'json',
				success: function (data) {
					if ($wrapper.attr('averageRating')!='0') {
						$wrapper.html(data.stars);
						$this.assignEvents();
					}
				}
			});
			$wrapper.attr('value', starValue);
			$wrapper.addClass('rated');
			var i = $('.bg-success .mr-auto:contains('+$vendor.getName()+')');
			if (i.length==0) {
				showToast(
					'success',
					$vendor.getName(),
					'just now',
					'Thanks for your rating!',
					3000
				);
			}
		}
	}

	this.assignEvents = function () {
		for (var i=1; i<=5; i++) {
			$this.getStar(i, 'false').hover($this.hover);
			$this.getStar(i, 'true').hover($this.hover);
			// $this.getStar(i, 'false').click($this.click);
			$this.getStar(i, 'true').click($this.click);
		}
		$wrapper.mouseleave($this.mouseleave);
	}

	$this.assignEvents();

//	$this.setRating($wrapper.attr('value'));
}